import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translations from './data/translations.json';

i18n.use(LanguageDetector).init({
  detection: {
    order: ['querystring'], // Read lang only from query string, do not cache
    lookupQuerystring: 'lang',
  },
  resources: translations,
  fallbackLng: 'fi',
  debug: false,
  interpolation: {},
  react: {
    bindI18n: 'languageChanged loaded',
    bindStore: 'added removed',
    nsMode: 'default',
  },
});

export default i18n;
